var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWandtresor = function SvgWandtresor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.935,
    height: 78.074
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wandtresor_svg__a",
    x1: -32.45,
    x2: -14.696,
    y1: 67.504,
    y2: 67.504,
    gradientTransform: "rotate(45 58.615 127.827)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.392,
    height: 17.138,
    fill: "#e03616",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 35.392,
    height: 17.138,
    x: 38.543,
    fill: "#e03616",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 35.392,
    height: 17.138,
    y: 40.558,
    fill: "#e03616",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 35.392,
    height: 17.138,
    x: 38.543,
    y: 40.558,
    fill: "#e03616",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 35.392,
    height: 17.138,
    x: 19.271,
    y: 20.279,
    fill: "#e03616",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 16.131,
    height: 17.138,
    y: 20.229,
    fill: "#e03616",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 16.196,
    height: 17.138,
    x: 57.739,
    y: 20.279,
    fill: "#e03616",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 16.131,
    height: 17.138,
    y: 60.886,
    fill: "#e03616",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 16.196,
    height: 17.138,
    x: 57.739,
    y: 60.936,
    fill: "#e03616",
    rx: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 35.392,
    height: 17.138,
    x: 19.271,
    y: 60.834,
    fill: "#e03616",
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 73.935,
    height: 78.074,
    fill: "#093a3e",
    opacity: 0.15,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "M71.935 0H20.751a25.2 25.2 0 0 0-2.024 5.522c-.825 3.503-.495 7.442 1.666 10.321 3.778 5.032 11.258 5.064 16.704 8.215a15.86 15.86 0 0 1 7.272 9.44c.43 1.575.654 3.3 1.725 4.533 1.902 2.187 5.326 1.744 8.206 1.416a41.4 41.4 0 0 1 19.635 2.57V2a2 2 0 0 0-2-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.769 41.277c4.515-4.667 7.91-11.056 4.28-18.404-7.028-3.472-13.178-.517-17.784 3.697l-.014.013q-.452.414-.884.842l-.035.035q-.424.42-.827.851l-.045.048q-.403.432-.786.869l-.032.037a46.3 46.3 0 0 0-6.105 9.028l4.321 4.32-2.324 2.325a.986.986 0 0 0-1.217.131L22.7 55.687a1.993 1.993 0 0 0-.134 2.665 2 2 0 0 0 .134.164l.707.707a2 2 0 0 0 2.829 0l10.618-10.618a.986.986 0 0 0 .131-1.217l2.324-2.324 4.321 4.32a46.4 46.4 0 0 0 8.141-5.352l.267-.222q.63-.523 1.253-1.09l.015-.015a34 34 0 0 0 1.464-1.428",
    opacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M58.919 20.301c-15.334-7.573-26.512 15.42-26.512 15.42l5.546 5.546 5.546 5.546S66.492 35.635 58.919 20.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wandtresor_svg__a)",
    d: "M45.184 20.97a28.9 28.9 0 0 0-7.437 6.626c5.608 3.326 9.92 9.719 12.67 14.838a35.8 35.8 0 0 0 5.38-4.987c-6.99-4.27-9.626-11.404-10.613-16.476",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#849b9f",
    d: "m35.12 46.551-2.45-2.45 5.212-5.212 2.407.045.043 2.405z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#01b2c4",
    d: "m23.276 56.652-.707-.708a2 2 0 0 1 0-2.828l10.618-10.618a1 1 0 0 1 1.414 0l2.122 2.121a1 1 0 0 1 0 1.414L26.104 56.652a2 2 0 0 1-2.828 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7bd3de",
    d: "m36.723 44.619-1.005-1.005a1 1 0 0 1 0 1.414L25.1 55.647a1.993 1.993 0 0 1-2.665.134 2 2 0 0 0 .134.163l.707.708a2 2 0 0 0 2.828 0l10.619-10.619a1 1 0 0 0 0-1.414"
  }))));
};
export default SvgWandtresor;